<section class="vc_row pt-60 pb-60">
  <div class="container">
    <div class="row"><app-steps-description [stepsDescription]="stepsDescription"></app-steps-description></div>
  </div>
</section>
